<template>
  <div>
    <div
      v-for="(config, i) in modules"
      :key="10+i"
    >
      <v-list-item
        v-if="!config.submenu"
        :to="'/modules/'+ config.path"
        class="v-list-item"
      >
        <v-list-item-action>
          <IconCustom :name="config.icon" />
        </v-list-item-action>
        <v-list-item-title>{{ config.name[$i18n.locale] }}</v-list-item-title>
      </v-list-item>
      <v-list-group
        v-else
        :value="false"
        no-action
      >
        <template #prependIcon>
          <IconCustom :name="config.icon" />
        </template>
        <template #activator>
          <v-list-item-content>
            <v-list-item-title>{{ config.name[$i18n.locale] }}</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item
          v-for="(item, idx) in config.submenu"
          :key="idx"
          :to="`/modules/${config.path}/${item.path}`"
          class="v-list-item"
        >
          <v-list-item-title>{{ item.name[$i18n.locale] }}</v-list-item-title>
        </v-list-item>
      </v-list-group>
    </div>
  </div>
</template>

<script>
import IconCustom from "@/components/helper/IconCustom.vue";

export default {
  components: { IconCustom },
  props: {
    modules: {
      type: Array,
      default: () => []
    }
  },
};
</script>
